import React from 'react'
import { Segment, Header } from 'semantic-ui-react'
import SponsorForm from '../../components/advertisement/sponsorForm'

const EditSponsor = props => {
  const { location } = props
  const { sponsorData } = location.state
  const firebaseKey = sponsorData.sponsorKey

  return (
    <div>
      <Segment color="black">
        <Header size="large"> Edit Sponsor </Header>
        <SponsorForm firebaseKey={firebaseKey} action="edit" sponsorData={sponsorData} />
      </Segment>
    </div>
  )
}

export default EditSponsor



// WEBPACK FOOTER //
// ./src/containers/advertisement/editSponsor.js